import { TypographyProps } from "@chakra-ui/react";
import { ColorProps } from "@chakra-ui/styled-system";

export type TextVariant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "h6Bold"
  | "overline"
  | "bodyBold"
  | "body"
  | "small"
  | "smallBold"
  | "caption"
  | "helper"
  | "label";

export const textStyles: Record<TextVariant, TypographyProps & ColorProps> = {
  h1: {
    fontSize: 40,
    fontWeight: 400,
    lineHeight: "48px",
    textColor: "gray.800",
  },
  h2: {
    fontSize: 32,
    fontWeight: 400,
    lineHeight: "39px",
    textColor: "gray.800",
  },
  h3: {
    fontSize: 24,
    fontWeight: 400,
    lineHeight: "29px",
    textColor: "gray.800",
  },
  h4: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: "24px",
    textColor: "gray.800",
  },
  h5: {
    fontSize: 18,
    fontWeight: 400,
    lineHeight: "22px",
    textColor: "gray.800",
  },
  h6: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "20px",
    textColor: "gray.800",
  },
  h6Bold: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "20px",
    textColor: "gray.800",
  },
  overline: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.025em",
    lineHeight: "15px",
    textColor: "gray.500",
  },
  body: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "20px",
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    color: "gray.500",
  },
  bodyBold: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
  },
  small: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "16px",
  },
  smallBold: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "16px",
  },
  caption: {
    fontSize: 10,
    fontWeight: 400,
    lineHeight: "normal",
  },
  helper: {
    fontSize: "12px",
    textColor: "gray.600",
  },
};
